import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ObjectViewLayout from '@/components/layouts/ObjectViewLayout';
import { paths } from '@/app/routes';
import { useObjectContext } from '@/hooks/useObjectContext';
import { ClientTabView } from './ClientTabView';
import { AdviserAboutCard } from './AdviserAboutCard';

const ClientViewWrapper = () => {
	const { pathname, state } = useLocation();
	const navigate = useNavigate();
	const { clientId } = useParams();
	const { clientRow } = useObjectContext();

	useEffect(() => {
		if (pathname.startsWith(paths.clients) && clientRow?.isProspect) {
			navigate(`${paths.prospects}/${clientId}`, { replace: true, state });
		} else if (pathname.startsWith(paths.prospects) && !clientRow?.isProspect) {
			navigate(`${paths.clients}/${clientId}`, { replace: true, state });
		}
	}, [pathname, clientId, clientRow?.isProspect]);

	return (
		<ObjectViewLayout
			tabView={<ClientTabView />}
			aboutCard={<AdviserAboutCard />}
		/>
	);
};

ClientViewWrapper.displayName = 'ClientViewWrapper';

export default ClientViewWrapper;
